import React, { useState } from 'react';
import './scss/Login.scss';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from './img/logo-sts.svg';
import { FaUser, FaLock } from 'react-icons/fa';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

const handleLogin = async (e) => {
  e.preventDefault();
  setErrorMsg('');

  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);

  try {
    const res = await fetch('/core/auth.php', {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    const data = await res.json();

    if (data.success) {
      toast.success("✅ Welcome back!");
      onLogin(); // <-- ahora sí dispara el cambio de vista a STSForm
    } else {
      toast.error(`❌ ${data.error}`);
    }
  } catch (err) {
    console.error(err);
    toast.error("❌ Something went wrong. Try again.");
  }
};


  return (
    <div className="login-wrapper">
      <div className="left-panel" />
      <div className="right-panel">
        <form className="login-form" onSubmit={handleLogin}>
          <img src={logo} className="logo" alt="STS" />
          <h2 className="form-title">Welcome</h2>
          <p className="form-subtitle">Login to continue</p>

          {errorMsg && <p className="error-message">{errorMsg}</p>}

          <div className="input-group">
            <FaUser />
            <input
              type="text"
              placeholder="Username"
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <FaLock />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </span>
          </div>

          <div className="form-footer">
            <a
              className="forgot-password"
              href="mailto:it@solucinde.com?subject=STS - Forgot my password&body=Hello, I forgot my STS access credentials. Please help me recover access."
            >
              Forgot your password?
            </a>
          </div>

          <button type="submit" className="login-btn">Login</button>

          {/* Oculto temporalmente */}
          {/* <button type="button" className="btn btn-outline-primary w-100 mt-2" disabled>
            Create an account
          </button> */}
        </form>
      </div>

      <ToastContainer position="top-right" autoClose={2500} hideProgressBar theme="colored" />
    </div>
  );
}

export default Login;
